export interface INFTHistoryFilter {
  text: string
  key: string
}

export const NFTHistoryFilterList: INFTHistoryFilter[] = [
  {
    text: 'Listing',
    key: 'Listed'
  },
  {
    text: 'Purchases',
    key: 'Buy'
  },
  {
    text: 'Sold',
    key: 'Sold'
  },
  {
    text: 'Removing',
    key: 'Removed'
  }
]
